// extracted by mini-css-extract-plugin
module.exports = {"content":"additionalField_content__pJ3UV","image":"additionalField_image__Q3SfG"};